import {EntityTypes} from "web-shared";
import {IdTextStateModel} from 'common-shared';

export class GraphFilterBy extends IdTextStateModel {
  Type: EntityTypes;
}

export class GraphOptions {
  ItemLevels = {
    Top: 5,
    Bottom: 5
  };
  IncludeTypes: EntityTypes[] = [EntityTypes.MasterOperation, EntityTypes.Item, EntityTypes.Resource, EntityTypes.Material, EntityTypes.ItemGroup];
  GroupBy: EntityTypes[] = [];
  Id: string;
  HideByFalseValidCondition: boolean = true;
  ShowSharedBranchesSeparately: boolean = true;
  AreAlternativeInstructionsSkipped: boolean = false;
  IsTopGraphShown: boolean = true;
  IsBottomGraphShown: boolean = true;
  MaximumLevel: number = 30;
  FilterBy: GraphFilterBy[];

  constructor(init?: Partial<GraphOptions>) {
    Object.assign(this, init);
  }
}
